import {connect} from 'react-redux';
import Registration from './Registration';
import {getNextStep} from '../../actions/getNextStep';
import {setRegType} from '../../actions/setRegType';
import {setLocale} from '../../actions/locales/setLocale';

const mapStateToProps = ({
                           nextStep: {nextStep}
                         }) => ({
  nextStep
});

export default connect(
  mapStateToProps,
  {getNextStep, setRegType, setLocale}
)(Registration);
